/** common */
export const LOCAL_STORAGE_KEYS = {
  AUTH: 'auth',
  SELECTED_BRANCH_ID: 'selectedBranchId',
} as const;

/** GET /partner/v1/users/permissions response.data.permissions의 key에 매핑할 텍스트 */
export const MENU_GROUPS = {
  PARTNER: { sort: 1, label: '파트너 메뉴' },
  ADMIN: { sort: 2, label: '관리자 메뉴' },
} as const;

/** user */
export const USER_ROLE = {
  PARTNER: '파트너',
  ADMIN: '관리자',
} as const;

export const USER_STATUS = {
  ACTIVE: '활성',
  INACTIVE: '비활성',
} as const;

/** biz.user.user_type */
export const USER_TYPE = {
  PARTNER: '파트너',
  ADMIN: '어드민',
} as const;

/** biz.user_role.type */
export const USER_ROLE_TYPE = {
  SUPER_ROLE: '최고 관리자',
  ADMIN: '관리자',
  PARTNER: '파트너',
  DEFAULT: '기본 역할',
} as const;

/** biz.user_permission.usage_type */
export const USER_PERMISSION_USAGE_TYPE = {
  MENU: '메뉴',
  API: 'API',
} as const;

/** biz.user_branch.status */
export const USER_BRANCH_STATUS = {
  ACTIVE: '활성',
  INACTIVE: '비활성',
} as const;

/** 전체 지점 접근 API 권한 코드 (dalock V219) */
export const BRANCH_ALL_ACCESS_PERMISSION = 'BRANCH_ALL_ACCESS';

/** contract */
export const CONTRACT_STATUS = {
  RESERVED: '계약중',
  NOT_PAID: '처분 예정',
  CONTRACT_END: '계약 종료',
  CANCELED: '계약 취소',
} as const;

export const CUSTOMER_TYPE = {
  NORMAL: '개인회원',
  BUSINESS: '법인회원',
} as const;

/** unit */
export const UNIT_TYPE = {
  MINI: '미니',
  COMPACT: '컴팩트',
  CUBE: '큐브',
  SLIM: '슬림',
  SMALL: '스몰',
  MEDIUM: '미디움',
  LARGE: '라지',
  CUBE_PLUS: '큐브플러스',
  SLIM_PLUS: '슬림플러스',
  SMALL_PLUS: '스몰플러스',
  MEDIUM_PLUS: '미디움플러스',
  LARGE_PLUS: '라지플러스',
  ETC: '기타',
} as const;

/** product */
export const PRODUCT_ORDER_STATUS = {
  PENDING_PAYMENT: '입금대기',
  PAYMENT_CONFIRMED: '입금확인',
  PREPARING: '준비중',
  HOLD: '보류',
  CANCELLED: '취소',
  COMPLETED: '완료',
} as const;

export const BANK_TRANSFER_INFO = {
  METHOD_NAME: '계좌이체',
  ACCOUNT: '하나은행 352-910021-95104 (주)세컨신드롬',
} as const;

export const POLICY_FILES = {
  POLICY: 'index.html',
  POLICY_PRIVATE: 'private.html',
} as const;
